import { mount } from 'svelte';
import ResultatsSessionGroupe from './test-maturite/ResultatsSessionGroupe.svelte';

mount(ResultatsSessionGroupe, {
  target: document.getElementById('resultats-session-groupe')!,
});
